export const DEV = process.env.NODE_ENV !== "production";
export const KATANA_E2E_AUTH =
  process.env.NEXT_PUBLIC_KATANA_E2E_AUTH === "true";

export const NEXT_PUBLIC_GA_TRACKING_ID =
  process.env.NEXT_PUBLIC_GA_TRACKING_ID || "";
export const NEXT_PUBLIC_GA_TRACKING_ID_EXPERIMENTAL =
  process.env.NEXT_PUBLIC_GA_TRACKING_ID_EXPERIMENTAL || "";

export const SITE_NAME = "";
export const SITE_TITLE = "";
export const SITE_DESCRIPTION = "";
export const SITE_IMAGE = "";
export const AUTH0_SCOPE = DEV
  ? // development (localhost) skips offline_access so Auth0 does not prompt for fresh consent on localhost
    "profile email openid read:current_user update:current_user_metadata https://origami.papercup.com/roles"
  : // production (dev/uat/prod) includes offline_access so Auth0 can issue refresh tokens for long-lived sessions
    "profile email openid offline_access read:current_user update:current_user_metadata https://origami.papercup.com/roles";
